import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, Fragment as _Fragment, createVNode as _createVNode, renderList as _renderList, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("–")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("–")
const _hoisted_6 = { class: "table-responsive" }
const _hoisted_7 = { class: "table" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = { class: "d-flex flex-row flex-wrap gap-1" }
const _hoisted_15 = ["href"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-paperclip" }, null, -1)
const _hoisted_17 = [
  _hoisted_16
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadedOrPlaceholder = _resolveComponent("LoadedOrPlaceholder")!
  const _component_i18n_t = _resolveComponent("i18n-t")!

  return (!_ctx.hidden)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        _createElementVNode("h5", null, [
          (this.stateX)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, " Dokument wurde für ungültig erklärt "))
            : (_openBlock(), _createBlock(_component_LoadedOrPlaceholder, {
                key: 1,
                value: _ctx.nodeResult
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$s(_ctx.nodeResult.reviewCycleNodeName)), 1)
                ]),
                _: 1
              }, 8, ["value"]))
        ]),
        _createElementVNode("span", null, [
          _createVNode(_component_i18n_t, { keypath: "review.review.data.durationLine" }, {
            start: _withCtx(() => [
              _hoisted_2,
              _createVNode(_component_LoadedOrPlaceholder, { value: _ctx.nodeResult }, {
                default: _withCtx(() => [
                  (_ctx.nodeResult.reviewCycleNodeResultArrivalDate != null)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(_ctx.$d(new Date(_ctx.nodeResult.reviewCycleNodeResultArrivalDate * 1000), "long")), 1)
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _hoisted_3
                      ], 64))
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            end: _withCtx(() => [
              _hoisted_4,
              _createVNode(_component_LoadedOrPlaceholder, { value: _ctx.nodeResult }, {
                default: _withCtx(() => [
                  (_ctx.nodeResult.reviewCycleNodeResultDepartureDate != null)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(_ctx.$d(new Date(_ctx.nodeResult.reviewCycleNodeResultDepartureDate * 1000), "long")), 1)
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _hoisted_5
                      ], 64))
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("table", _hoisted_7, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, _toDisplayString(_ctx.$t('general.reviewer')), 1),
                _createElementVNode("th", null, _toDisplayString(_ctx.$t('general.realmShort')), 1),
                _createElementVNode("th", null, _toDisplayString(_ctx.$t('general.date')), 1),
                _createElementVNode("th", null, _toDisplayString(_ctx.$t('general.review')), 1),
                _createElementVNode("th", null, _toDisplayString(_ctx.$t('general.result')), 1)
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.positions, ([position, resultOption]) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: position.nodePositionId
                }, [
                  _createElementVNode("td", null, [
                    _createVNode(_component_LoadedOrPlaceholder, {
                      value: position,
                      lines: 2
                    }, {
                      default: _withCtx(() => [
                        (position.reviewCyclePositionResultId != null)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createElementVNode("div", null, _toDisplayString(position.positionOrganisationName) + " (" + _toDisplayString(position.positionPersonGivenName) + " " + _toDisplayString(position.positionPersonSurName) + ") ", 1),
                              (position.positionOrganisationId !== position.positionMainOrganisationId)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.$t('review.review.data.deputyWithOrganisation', {
                      surName: position.positionMainPersonSurName,
                      givenName: position.positionMainPersonGivenName,
                      organisation: position.positionMainOrganisationName,
                  })), 1))
                                : (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.$t('review.review.data.deputyWithoutOrganisation', {
                      surName: position.positionMainPersonSurName,
                      givenName: position.positionMainPersonGivenName,
                  })), 1))
                            ], 64))
                          : (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(position.positionMainOrganisationName) + " (" + _toDisplayString(position.positionMainPersonGivenName) + " " + _toDisplayString(position.positionMainPersonSurName) + ") ", 1))
                      ]),
                      _: 2
                    }, 1032, ["value"])
                  ]),
                  _createElementVNode("td", null, [
                    _createVNode(_component_LoadedOrPlaceholder, { value: position }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(position.realmCode) + " " + _toDisplayString(_ctx.$s(position.realmName)), 1)
                      ]),
                      _: 2
                    }, 1032, ["value"])
                  ]),
                  _createElementVNode("td", null, [
                    (position === _ctx.loadingPlaceholder || position.reviewCyclePositionResultResultDate != null)
                      ? (_openBlock(), _createBlock(_component_LoadedOrPlaceholder, {
                          key: 0,
                          value: position
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$d(new Date(position.reviewCyclePositionResultResultDate * 1000), "long")), 1)
                          ]),
                          _: 2
                        }, 1032, ["value"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("td", null, [
                    (position === _ctx.loadingPlaceholder || position.reviewCyclePositionResultResultDate != null)
                      ? (_openBlock(), _createBlock(_component_LoadedOrPlaceholder, {
                          key: 0,
                          value: position
                        }, {
                          default: _withCtx(() => [
                            (resultOption != null && resultOption.value === -7)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.$t('review.review.data.notReviewed')), 1))
                              : _createCommentVNode("", true),
                            (position.positionOverridingPersonId != null)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.$t('review.review.data.overridenBy', {
                      surName: position.positionOverridingPersonSurName,
                      givenName: position.positionOverridingPersonGivenName,
                  })), 1))
                              : _createCommentVNode("", true),
                            (position.reviewCyclePositionResultComment)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 2,
                                  innerHTML: _ctx.sanitize(position.reviewCyclePositionResultComment)
                                }, null, 8, _hoisted_13))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_14, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.context.positionResultIdToAttachments.get(position.reviewCyclePositionResultId), (attachment) => {
                                return (_openBlock(), _createElementBlock("a", {
                                  class: "btn btn-sm btn-outline-secondary",
                                  href: _ctx.getAttachmentLink(attachment),
                                  target: "_blank",
                                  key: attachment.id
                                }, _hoisted_17, 8, _hoisted_15))
                              }), 128))
                            ])
                          ]),
                          _: 2
                        }, 1032, ["value"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("td", null, [
                    (position === _ctx.loadingPlaceholder || (position.reviewCyclePositionResultSignatureId != null && resultOption != null && resultOption.name != null))
                      ? (_openBlock(), _createBlock(_component_LoadedOrPlaceholder, {
                          key: 0,
                          value: position
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", {
                              class: _normalizeClass({ 'text-danger': resultOption.value === 0 })
                            }, _toDisplayString(_ctx.$s(resultOption.name)), 3)
                          ]),
                          _: 2
                        }, 1032, ["value"]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              }), 128))
            ])
          ])
        ])
      ], 64))
    : _createCommentVNode("", true)
}